import { useState } from 'react';
import { useParams } from 'react-router-dom';
import LandingHeader from './components/LandingHeader';
import LeadForm from './components/LeadForm';
import FormSuccess from './components/FormSuccess';
import classes from './style.module.css';

const Landing = () => {
  const { agentId } = useParams();
  const [submitted, setSubmitted] = useState(false);

  return (
    <div className={classes.page}>
      <div className={classes.heroBg} aria-hidden="true" />

      <div className={classes.content}>
        <LandingHeader />

        <header className={classes.hero}>
          <h1 className={classes.title}>
            האם המשכנתא שלכם עולה יותר מדי?
            <br />
            בדקו עכשיו כמה תוכלו לחסוך
          </h1>
          <p className={classes.subtitle}>
            בדיקה ראשונית מהירה ללא עלות וללא התחייבות
          </p>
        </header>

        <div className={classes.card}>
          {submitted
            ? <FormSuccess />
            : <LeadForm agentId={agentId} onSuccess={() => setSubmitted(true)} />}
        </div>
      </div>
    </div>
  );
};

export default Landing;
